import React, { forwardRef } from "react";
import InputValidationError from "~/components/TextInput/InputValidationError";
import { twMerge } from "tailwind-merge";
import BasicTextInput from "~/components/TextInput/BasicTextInput";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  errorMessage?: string;
  containerClassName?: string;
};

const ValidatedBasicTextInput = forwardRef(
  (
    { errorMessage, containerClassName, ...rest }: Props,
    ref: React.Ref<HTMLInputElement>
  ) => {
    return (
      <div className={twMerge(containerClassName)}>
        <BasicTextInput
          type={rest.type || "text"}
          ref={ref}
          aria-invalid={errorMessage ? "true" : "false"}
          {...rest}
        />
        {errorMessage && (
          <InputValidationError>{errorMessage}</InputValidationError>
        )}
      </div>
    );
  }
);

ValidatedBasicTextInput.displayName = "ValidatedBasicTextInput";

export default ValidatedBasicTextInput;
